import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { LeveledEffectAction } from "../EffectActions/LeveledEffectAction";
import { Qualifier } from "../../../internal/qualifier/Qualifier";
import { QualifierValue } from "../../../internal/qualifier/QualifierValue";
import { prepareColor } from "../../../internal/utils/prepareColor";
/**
 * @description Makes the background of the image transparent (or solid white for formats that do not support transparency).
 * @extends LeveledEffectAction
 * @memberOf Actions.Effect
 * @see Visit {@link Actions.Effect|Effect} for an example
 */

var MakeTransparentEffectAction = /*#__PURE__*/function (_LeveledEffectAction) {
  _inherits(MakeTransparentEffectAction, _LeveledEffectAction);

  var _super = _createSuper(MakeTransparentEffectAction);

  function MakeTransparentEffectAction() {
    _classCallCheck(this, MakeTransparentEffectAction);

    return _super.apply(this, arguments);
  }

  _createClass(MakeTransparentEffectAction, [{
    key: "tolerance",
    value:
    /**
     * @description Sets the tolerance used to accommodate variance in the background color.
     * @param {number | string} value The tolerance used to accommodate variance in the background color. (Range: 0 to 100, Server default: 10)
     */
    function tolerance(value) {
      return this.setLevel(value);
    }
    /**
     * @description Sets the color to make transparent.
     * @param {string} color The HTML name of the color (red, green, etc.) or RGB hex code.
     * @return {this}
     */

  }, {
    key: "colorToReplace",
    value: function colorToReplace(color) {
      return this.addQualifier(new Qualifier('co', new QualifierValue(prepareColor(color))));
    }
  }]);

  return MakeTransparentEffectAction;
}(LeveledEffectAction);

export { MakeTransparentEffectAction };